import ApiService from "../../../../ApiService";

const EditService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/promotion/management/edit/loadscreenview", { id }, successCallback, failureCallback);
    },

    savePromotion: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/promotion/management/edit/save", vo, successCallback, failureCallback);
    },

    upload: (vo, successCallback, failureCallback) => {
        let formData = new FormData();
        formData.append("fileData", vo.file);
        formData.append("table", "Promotion");
        formData.append("field", "Banners");
        ApiService.postFileToServer("/common/file/upload", formData, successCallback, failureCallback);
    }
};

export default EditService;
